import SessionService from '@/services/session.service';



let products = SessionService.getItem('products', [])

export default {
  namespaced: true,
  strict: true,
  state: {
    products: products,
    cartCount: products.length,
    product: products.index
  },
  mutations: {
    ADD_TO_CART(state, product) {
      state.products.push(product);
      SessionService.setItem('products', state.products)
      state.cartCount = state.products.length;
    },
    REMOVE_PRODUCTS(state) {
      SessionService.removeItem('products', state.products = []);
      state.cartCount = 0;
    },
    REMOVE_PRODUCT(state, index) {
      state.products.splice(index, 1)
      SessionService.setItem('products', state.products)
      state.cartCount = state.products.length;
    }
  },
  actions: {
    // Product toevoegen
    addProduct({ commit }, products) {
      commit('ADD_TO_CART', products)
    },
    // Product verwijderen
    removeProducts({ commit }) {
      commit('REMOVE_PRODUCTS', [])
    },
    removeProduct({ commit }, products) {
      commit('REMOVE_PRODUCT', products)
    }
  },
  getters: {}
}